import React,{useState,useEffect} from 'react';
import { Link } from 'react-router-dom';
import { imgUrlSite } from '../../common/service/common';
import {timeFormat} from '../../common/service/Tools';

function Detail(props) {
    const [recs, setrecs] = useState([]);
    //const detailData = {};
    const [detailData, setdetailData] = useState({});

    const id = props.match.params.id;

    useEffect(() => {
        React.$http.helper_get_detail({id,type:1}).then(res=>{
            if(res&&res.help) {
                setdetailData(res.help);
                React.$http.admin_get_help_list({classify:res.help.classifyCode}).then(res=>{
                    if(res&&res.helpEntities) {
                        setrecs(res.helpEntities.slice(0,5));
                    }
                });
            }
        })
        return () => {
            
        };
    }, [id]);

    return (
            <div className="mainWrap detail-wrap">
                <div className="detail f-l">
                    <div className="detailInfo">
                        <h2>{detailData.title}</h2>
                        <div className="user-ctrls">
                            <div className="teacher f-l">
                                <span className="date f-r"><i>·</i>{timeFormat(detailData.addTime)}</span>
                                <div className="teacher-info f-l">
                                    <div className="teacher-header">
                                        <img src={detailData.imgUrl?imgUrlSite+detailData.imgUrl:'/assets/images/head1.png'} alt=""/>
                                    </div>
                                </div>
                                <div className="tearcher-name f-l">
                                    {detailData.userName}
                                </div>
                            </div>
                            <div className="clear"></div>
                        </div>
                        
                        <div className="content" dangerouslySetInnerHTML={{__html:detailData.content}}>
                        </div>                        
                    </div>
                
                </div>
                <div className="rightSide f-r">
                    <div className="area" style={{ width: '308px'}}>
                        <h2><span className="name">相关推荐</span></h2>
                        <div className="list">
                        {
                            recs.length>0?recs.map((item,key)=>{
                                return (
                                    <div className="like-article-item" key={key}>
                                        <div className="title"><Link to={'/detail/'+item.helpId}>{item.title}</Link></div>                                        
                                    </div>
                                )
                            }):<div style={{textAlign:'center',padding:10}}>暂无相关推荐</div>
                        } 
                        </div>
                    </div>
                </div>
        </div>
    )
}

export default Detail;